import axios from "axios";
const API_URL = "/api/fsd/";

// #22 — fetch the FSD roster for the "Who recommended you for AGA?" dropdown.
const list = async () => {
  const response = await axios.get(API_URL);
  return response.data?.fsds ?? [];
};

const fsdService = { list };

export default fsdService;
